import axios from "axios";

export default {


    async requestToken(params) {

     // return new Promise((resolve, reject) => {

      const config = {
        url: process.env.VUE_APP_BASE_API+"/"+ "negocio/login",
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        data: JSON.stringify({usuario: params.usuario, password: params.password}),
    };
    const response = await  axios(config);


    if(response.status == 200){
        return (await response).data;
    } else {
        return false;
    }
 // })   
   
    },
    async validateToken(params) {

 
       const config = {
         url: process.env.VUE_APP_BASE_API+"/"+ "negocio/user/email/verify_recovery_token",
         method: 'POST',
         headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
         },
         data: JSON.stringify({token: params.token}),
     };
     const response = await  axios(config);
 
 
     if(response.status == 200){
         return (await response).data;
     } else {
         return false;
     }
    
     },

  };